import {DasqlOperation} from '../enums/dasql-operation';
import {DasqlNode} from './dasql-node';

export abstract class MultipleLeafOperationDasqlNode extends DasqlNode {
  constructor(private operation: DasqlOperation, private children: DasqlNode[]) {
    super();
  }

  public emit(): string {
    return `(${this.children
      .filter(child => !!child)
      .map(child => child.emit())
      .join(` ${this.operation} `)})`;
  }
}
